import { FIREBASE_FUNCTION_HEADERS } from "@/revamp/firebase/config";
import { logError, request } from "@/revamp/utils";

async function verifyCode(code) {
  try {
    let response = await fetch(
      `${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/VerifyCode`,
      {
        method: "POST",
        headers: FIREBASE_FUNCTION_HEADERS,
        body: JSON.stringify({ code: code }),
      }
    );
    return await response.json();
  } catch (e) {
    logError(`QRCodeFunctions.verifyCode: Failed to verify code ${code}`);
    return null;
  }
}

async function onBorrowVerify(codeID) {
  try {
    let response = await fetch(
      `${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/onScanBorrow`,
      {
        method: "POST",
        headers: FIREBASE_FUNCTION_HEADERS,
        body: JSON.stringify({
          id: codeID,
        }),
      }
    );
    return await response.json();
  } catch (e) {
    logError(
      `OutletFunctions.outletQuickClaim Failed to claim code ${codeID} ${e.toString()}`
    );
    return null;
  }
}

async function claimCode(code, email, scanalytics, pin = null, claimType = null, isUnauthenticated = false) {
  try {
    let response = await request(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/ClaimCode`,
      "POST",
      {
        code: code,
        email: email,
        scanalytics: scanalytics,
        claimType: claimType,
        checkDigits: pin,
      },
      'QRCodeFunctions.claimCode',
      !isUnauthenticated
    );
    return response;
  } catch (e) {
    logError(`QRCodeFunctions.ClaimCode Failed to claim code ${code}`);
    return { error: true, code: e.response?.code, message: e.response?.message };
  }
}

async function claimCodeByUrl(url, scanalytics) {
  try {
    let response = await request(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/ClaimCodeByUrl`,
      "POST",
      {
        url: url,
        scanalytics: scanalytics,
      },
      'QRCodeFunctions.claimCodeByUrl',
      true
    );
    return response;
  } catch (e) {

    logError(`QRCodeFunctions.ClaimCodeByUrl Failed to claim code ${url}`);
    return { error: true, code: e.response?.code, message: e.response?.message };
  }
}

async function claimCodeByUrlFastlane(url, email, scanalytics) {
  try {
    let response = await request(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/ClaimCodeByUrlFastlane`,
      "POST",
      {
        url: url,
        email: email,
        scanalytics: scanalytics,
      },
      'QRCodeFunctions.claimCodeByUrlFastlane',
      false
    );
    return response;
  } catch (e) {

    logError(`QRCodeFunctions.ClaimCodeByUrlFastlane Failed to claim code ${url}`);
    return { error: true, code: e.response?.code, message: e.response?.message };
  }
}

async function claimCodeByUrlQuickClaim(url, email, emailLanguage, charityId, scanalytics) {
  try {
    let response = await request(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/ClaimCodeByUrlQuickClaim`,
      "POST",
      {
        url: url,
        email: email,
        emailLanguage: emailLanguage,
        charityId: charityId,
        scanalytics: scanalytics,
      },
      "QRCodeFunctions.claimCodeByUrlQuickClaim",
      false
    );
    return response;
  } catch (e) {
    logError(`QRCodeFunctions.claimCodeByUrlQuickClaim error: ${url}`);
    return { error: true, code: e.response?.code, message: e.response?.message };
  }
}

async function allowQuickClaim(url) {
  try {
    let response = await request(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/quickClaimAllow`,
      "POST",
      {
        url: url,
      },
      "QRCodeFunctions.allowQuickClaim",
      false
    );
    return response.data.allowQuickClaim;
  } catch (e) {
    logError(`QRCodeFunctions.allowQuickClaim error: ${url}`);
    return false;
  }
}

async function claimBorrowedCodes(codes, userURL) {
  try {
    let response = await fetch(
      `${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/borrowClaimCode`,
      {
        method: "POST",
        headers: FIREBASE_FUNCTION_HEADERS,
        body: JSON.stringify({
          codes: codes,
          userURL: userURL,
        }),
      }
    );
    return await response.json();
  } catch (e) {
    logError(
      `QRCodeFunctions.claimBorrowedCodes Failed to claim codes ${codes}`
    );
    return null;
  }
}

async function quickClaimCheck(code) {
  try {
    const response = await request(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/quickClaimCheck`, "POST", { id: code }, 'QRCodeFunctions.quickClaimCheck', false);
    return response.data;
  } catch (e) {
    logError(`QRCodeFunctions.quickClaimCheck: Failed to check quick claim for code ${code}`);
    return null;
  }
}

async function verifyPin(codeID, pin) {
  try {
    let response = await request(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/verifyCodeCheckDigits`, "POST", { id: codeID, pin: pin }, 'QRCodeFunctions.verifyPin', false);
    return response.data.valid;
  } catch (e) {
    logError(`QRCodeFunctions.verifyPin: Failed to verify pin for code ${codeID}`);
    return null;
  }
}

async function scanReturnBin(url, dryRun = false) {
  try {
    const response = await request(
      `${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/scanReturnBin`,
      "POST",
      { url, ...(dryRun && { dryRun: true }) },
      "QRCodeFunctions.scanReturnBin",
      true
    );
    return response;
  } catch (e) {
    const rawMessage = e instanceof Error ? e.message : String(e);
    logError(`QRCodeFunctions.scanReturnBin: Failed for url ${url}. ${rawMessage}`);
    return { error: true, message: rawMessage };
  }
}

const qrCodes_functions = {
  verifyCode,
  claimCode,
  claimCodeByUrl,
  claimCodeByUrlFastlane,
  claimCodeByUrlQuickClaim,
  quickClaimCheck,
  onBorrowVerify,
  claimBorrowedCodes,
  verifyPin,
  scanReturnBin,
  allowQuickClaim
};

export default qrCodes_functions;
